import React from "react";

interface Practitioner {
  name: string;
}

interface Summary {
  practitioner: Practitioner;
  specialty: string;
  teleconsult_date: string;
  subject: string;
  object: string;
  assesment: string;
  plan: string;
  file_url: string;
}

const Summary: React.FC<{ summary: Summary }> = ({ summary }) => {
  return (
    <div
      style={{
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#eaf4ff",
        fontSize: "12px",
        // fontFamily: "Arial, sans-serif",
        // width: "100%", // Lebar penuh
        boxSizing: "border-box", // Pastikan padding tidak menambah lebar elemen
      }}
    >
      <p style={{ margin: "0 0 10px", color: "#00bfa5", textAlign:"center" }}><b>Consultation Summary</b></p>
      <hr style={{ border: "none", borderTop: "1px solid #ddd" }}  />
      <table>
        <tr>
          <td>Doctor</td>
          <td>:</td>
          <td>{summary.practitioner?.name || "N/A"}</td>
        </tr>
        <tr>
          <td>Speciality</td>
          <td>:</td>
          <td>{summary.specialty || "N/A"}</td>
        </tr>
        <tr>
          <td>Date</td>
          <td>:</td>
          <td>{summary.teleconsult_date || "N/A"}</td>
        </tr>
      </table>
     
      <hr style={{ border: "none", borderTop: "1px solid #ddd" }} />
      <table>
        <tr>
          <td>Subjek</td>
          <td>:</td>
          <td>{summary.subject || "N/A"}</td>
        </tr>
        <tr>
          <td>Objek</td>
          <td>:</td>
          <td>{summary.object || "N/A"}</td>
        </tr>
        <tr>
          <td>Asseessment</td>
          <td>:</td>
          <td>{summary.assesment || "N/A"}</td>
        </tr>
        <tr>
          <td>Plan</td>
          <td>:</td>
          <td>{summary.plan || "N/A"}</td>
        </tr>
        <tr>
          <td>Download File</td>
          <td>:</td>
          <td>  {summary.file_url ? (
                <a style={{textDecoration: "none"}} href={summary.file_url} target="_blank" rel="noopener noreferrer">
                  Summary
                </a>
              ) : (
                "N/A"
              )}</td>
        </tr>
      </table>
    </div>
  );
};

export default Summary;
